/**
 * @author silence
 * @desc:个人中心接口
 * */
// 带fp的都要token
import request from '@/utils/ajax';

export function queryMasterTraderInfo(data) {
	return request({
		url: '/crm/reception/subscriptionInfo',
		method: 'get',
        params:data,
        addToken:true,
	});
}


export function checkCopyPassword(data) {
  return request({
    url: '/crm/reception/checkSubPassword',
    method: 'get',
    params:data,
    addToken:true,
  });
}


export function addSubscription(data) {
  return request({
    url: '/crm/reception/addSubscription\t',
    method: 'post',
    data,
    addToken:true,
  });
}


export function queryStatistics(data) {
  return request({
    url: '/crm/reception/queryStatisticsDataByMtId',
    method: 'get',
    params: data,
    addToken:true,
  });
}

export function queryStatisticsSimple(data) {
  return request({
    url: '/crm/fp/queryStatisticsDataByMtId',
    method: 'get',
    params: data,
  });
}

//mam主账户 收益曲线
export function queryLoginProfitInfo(data) {
  return request({
    url: '/crm/reception/queryLoginProfitInfo',
    method: 'get',
    params: data,
  });
}

// MAM投资账户 收益曲线
export function queryCopyProfitInfo(data) {
  return request({
    url: '/crm/reception/queryCopyProfitInfo',
    method: 'get',
    params: data,
  });
}


// 订阅累计数据
export function queryCumulativeData(data) {
  return request({
    url: '/crm/reception/cumulativeData',
    method: 'get',
    params: data,
    addToken:true,
  });
}

// 编辑订阅
export function updateSubscription(data) {
  return request({
    url: '/crm/reception/updateSubscription',
    method: 'put',
    data,
    addToken:true,
  });
}

export function removeSubscription(data) {
  return request({
    url: '/crm/reception/removeSubscription',
    method: 'put',
    data,
    addToken:true,
  });
}

// 账户详情页面-信息概览（指标、订阅资金限制、收费模式）
export function getTraderOverview(data) {
  return request({
    url: '/crm/fp/queryAccountOverview',
    method: 'get',
    params:data,
  });
}

// 创建交易周期
export function addTradingCycle(data) {
  return request({
    url: '/crm/reception/addTradingCycle',
    method: 'post',
    data,
    addToken:true,
  });
}

//结算
export function settle(data) {
  return request({
    url: '/crm/reception/updateTradingCycle',
    method: 'post',
    data,
    addToken:true,
  });
}

//结算单个
export function settleOne(data) {
  return request({
    url: '/crm/reception/settleSingleCopy',
    method: 'post',
    data,
    addToken:true,
  });
}

// 期号列表
export function getIssueNumberList(data) {
  return request({
    url: '/crm/reception/queryMasterCycleAll',
    method: 'get',
    params: data,
    addToken:true,
  });
}


// 验证跟随账户是否可以享受免费体验期
export function checkExperience(data) {
  return request({
    url: '/crm/reception/checkExperience',
    method: 'get',
    params: data,
    addToken:true,
  });
}

export function checkSharable(data) {
  return request({
    url: '/crm/reception/checkSharable',
    method: 'get',
    params: data,
    addToken:true,
  });
}

export function queryShareInfo(data) {
  return request({
    url: '/crm/reception/getShareInfo',
    method: 'get',
    params: data,
    addToken:true,
  });
}
